/* vsx-interactive.js — devolve comportamento as secoes clonadas da viasox.
 *
 * O `scope_html` do section_kit remove TODO <script> da secao copiada (e o que
 * impede tracking/apps do concorrente de virem junto), o que deixa acordeao,
 * carrossel e "ver mais" INERTES. Este arquivo reimplementa os padroes do tema
 * do concorrente (Tailwind v4 + custom elements) em JS proprio.
 *
 * Padroes: (1) accordion-dropdown  (2) siema-slider-images
 *          (3) load-more do widget de reviews  (4) navegacao [data-vsx-goto]
 *
 * Escopo por TAG de elemento customizado — nenhuma existe no Shrine de fabrica.
 */
(function () {
  'use strict';

  var qsa = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  /* O `verify` injeta uma folha `data-cl-freeze` para congelar animacao antes
   * de fotografar. Autoplay rodando contra isso torna a foto nao-deterministica
   * (a referencia muda a cada corrida). Consultamos o marcador A CADA TICK
   * porque a folha e injetada DEPOIS do load. */
  function frozen() {
    return !!document.querySelector('style[data-cl-freeze], [data-cl-freeze]');
  }

  /* ------------------------------------------------------------------ *
   * 1. accordion-dropdown — FAQ das 3 paginas + guia de tamanhos da PDP
   *
   * <accordion-dropdown data-accordion-id="X" data-duration="500">
   *   <h5 data-accordion-toggle="X"> ... <svg .group-data-open:rotate-*> </h5>
   *   <div class="h-0 overflow-hidden opacity-0" data-accordion-content="X">
   *
   * O ICONE ja tem as variantes group-data-open no CSS copiado; o PAINEL nao
   * tem nenhuma — a altura e escrita inline aqui, como o tema do concorrente faz.
   * Itens sao INDEPENDENTES (varios podem ficar abertos ao mesmo tempo): e como
   * o concorrente se comporta, nao ha elemento de grupo no markup dele.
   * ------------------------------------------------------------------ */
  function initAccordion(root) {
    if (root.__vsxAcc) return;
    var id = root.getAttribute('data-accordion-id');
    var toggle = root.querySelector('[data-accordion-toggle]');
    var body = root.querySelector('[data-accordion-content]');
    if (!toggle || !body) return;
    root.__vsxAcc = true;

    var dur = parseInt(root.getAttribute('data-duration'), 10);
    if (!dur || isNaN(dur)) dur = 400;

    /* O extract fotografa o estado ABERTO e o outerHTML sai com o inline
     * `height:auto;opacity:1` baked. Se o elemento ainda carrega a classe que o
     * FECHA (h-0/opacity-0), o inline e ruido do instrumento — limpa. */
    if (/(^|\s)h-0(\s|$)/.test(body.className) && !root.hasAttribute('data-open')) {
      body.style.removeProperty('height');
      body.style.removeProperty('opacity');
    }

    var open = root.hasAttribute('data-open');
    if (id) {
      if (!body.id) body.id = 'vsx-acc-' + id;
      toggle.setAttribute('aria-controls', body.id);
    }
    if (!toggle.hasAttribute('role')) toggle.setAttribute('role', 'button');
    if (!toggle.hasAttribute('tabindex')) toggle.setAttribute('tabindex', '0');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    function paint(next, animate) {
      open = next;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) root.setAttribute('data-open', '');
      else root.removeAttribute('data-open');

      var ms = animate === false ? 0 : dur;
      body.style.transitionDuration = ms + 'ms';
      if (open) {
        body.style.opacity = '1';
        body.style.height = body.scrollHeight + 'px';
        // depois da transicao solta a altura: conteudo que reflui (imagem que
        // carrega, resize) nao pode ficar preso num pixel fixo
        window.setTimeout(function () {
          if (open) body.style.height = 'auto';
        }, ms + 20);
      } else {
        body.style.height = body.scrollHeight + 'px';
        void body.offsetHeight; // reflow: sem isso o browser nao anima de auto
        body.style.opacity = '0';
        body.style.height = '0px';
      }
    }

    function toggleIt(e) {
      if (e) e.preventDefault();
      paint(!open);
    }
    toggle.addEventListener('click', toggleIt);
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') toggleIt(e);
    });
    if (open) paint(true, false);
  }

  /* ------------------------------------------------------------------ *
   * 2. siema-slider-images — a faixa de fotos da PDP
   *
   * <siema-slider-images data-autoplay="true" data-autoplay-speed="6000">
   *   <div class="siema-peek">
   *     <div data-carousel-slides style="overflow:hidden">
   *       <div style="width:5920px;transform:translate3d(-493.334px,0,0)">
   *         <div style="float:left;width:4.16667%"> ... x24
   *
   * O transform inicial vem baked do extract (o concorrente ja estava no meio
   * do loop). Preservamos esse offset como ponto de partida para nao mexer no
   * pixel-diff, e so entao damos movimento.
   * ------------------------------------------------------------------ */
  function initSiema(host) {
    if (host.__vsxSiema) return;
    var viewport = host.querySelector('[data-carousel-slides]');
    if (!viewport) return;
    var track = viewport.firstElementChild;
    if (!track) return;
    var cells = Array.prototype.filter.call(track.children, function (n) {
      return n.nodeType === 1;
    });
    if (cells.length < 2) return;
    host.__vsxSiema = true;

    var speed = parseInt(host.getAttribute('data-autoplay-speed'), 10) || 6000;
    var autoplay = host.getAttribute('data-autoplay') === 'true';
    var timer = null;

    function slideW() {
      var a = cells[0].getBoundingClientRect();
      var b = cells[1].getBoundingClientRect();
      return Math.abs(b.left - a.left) || a.width;
    }
    function current() {
      var m = /translate3d\(\s*(-?[\d.]+)px/.exec(track.style.transform || '');
      return m ? -parseFloat(m[1]) : 0;
    }
    function perView() {
      var w = slideW();
      if (!w) return 1;
      return Math.max(1, Math.round(viewport.getBoundingClientRect().width / w));
    }
    function maxIndex() {
      return Math.max(0, cells.length - perView());
    }
    function paint(px, animate) {
      track.style.transitionDuration = animate === false ? '0ms' : '500ms';
      track.style.transform = 'translate3d(-' + px + 'px, 0px, 0px)';
    }

    var index = Math.round(current() / (slideW() || 1)) || 0;

    function go(i, animate) {
      var max = maxIndex();
      if (i > max) i = 0;          // volta ao inicio, como o Siema em loop
      if (i < 0) i = max;
      index = i;
      paint(index * slideW(), animate);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
      host.setAttribute('data-playback-state', 'paused');
    }
    function start() {
      if (timer || !autoplay) return;
      host.setAttribute('data-playback-state', 'playing');
      timer = window.setInterval(function () {
        if (frozen()) { stop(); return; }   // nao mexer durante o pixel-diff
        if (document.hidden) return;
        go(index + 1);
      }, speed);
    }

    /* setas, quando a secao as tiver */
    host.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-siema-next], [data-siema-prev]');
      if (!btn || !host.contains(btn)) return;
      e.preventDefault();
      stop();
      go(index + (btn.hasAttribute('data-siema-prev') ? -1 : 1));
    });

    /* arraste — o CSS do concorrente ja promete cursor: grab */
    var startX = 0, startPx = 0, dragging = false, moved = 0;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      dragging = true; moved = 0;
      startX = e.clientX;
      startPx = current();
      host.classList.add('vsx-dragging');
      stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      moved = e.clientX - startX;
      var px = Math.max(0, Math.min(startPx - moved, maxIndex() * slideW()));
      paint(px, false);
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      host.classList.remove('vsx-dragging');
      if (Math.abs(moved) < 8) { go(index); return; }
      go(Math.round((startPx - moved) / slideW()));
    });

    host.addEventListener('mouseenter', stop);
    host.addEventListener('mouseleave', start);
    window.addEventListener('resize', function () { go(index, false); });
    if (!frozen()) start();
  }

  /* ------------------------------------------------------------------ *
   * 3. "Show more reviews" — o botao do widget de reviews copiado
   *
   * O widget veio do app do concorrente com 4 reviews estaticos; nao existe
   * endpoint atras dele na NOSSA loja. Em vez de um botao morto, ele leva para
   * a pagina de reviews da loja.
   * ------------------------------------------------------------------ */
  function initLoadMore(btn) {
    if (btn.__vsxMore) return;
    btn.__vsxMore = true;
    btn.setAttribute('role', 'link');
    btn.style.cursor = 'pointer';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/pages/reviews';
    });
  }

  /* ------------------------------------------------------------------ *
   * 4. Navegacao por elemento nao-<a> (cards e CTAs que no concorrente abriam
   *    o quick-shop do tema dele). Algumas secoes ja tem handler proprio; este
   *    e o resgate global para as que nao tem.
   * ------------------------------------------------------------------ */
  function initGoto() {
    if (document.__vsxGoto) return;
    document.__vsxGoto = true;
    function nav(e) {
      var b = e.target.closest && e.target.closest('[data-vsx-goto]');
      if (!b) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      window.location.href = b.getAttribute('data-vsx-goto');
    }
    document.addEventListener('click', nav);
    document.addEventListener('keydown', nav);
  }

  /* ------------------------------------------------------------------ */
  function boot() {
    qsa('accordion-dropdown[data-accordion-id]').forEach(initAccordion);
    qsa('siema-slider-images').forEach(initSiema);
    qsa('#loadMore, [data-testid="load-more-button"]').forEach(initLoadMore);
    initGoto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // o theme editor do Shopify re-renderiza secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', boot);
  window.vsxInteractiveBoot = boot;
})();
